import React from "react";
import toLower from "lodash/toLower";
import { Checkbox, FormControlLabel } from "@mui/material";
import BSInput from "../../../common/js/components/BSInput";
import { buildingClasses } from "./constants";
import "./Multifamily.css";

const MultifamilyForm = (props) => {
    const { context, data, disableInputs, errors, listingStatus, onChange, transactionType } = props;

    const handleAttributeUpdate = (event) => {
        onChange(event.target.id, event.target.value);
    };
    const isAppraisalSale = toLower(transactionType) === "sale" && listingStatus === "Appraisal";

    return (
        <div>
            {context === "property" && (
                <div>
                    <div className="multifamilyFlexContainer">
                        <div className="flexGrowSingle">
                            <BSInput
                                id="officeSf"
                                label="OFFICE SPACE"
                                placeholder="Enter SF"
                                errorText="ex. 98101"
                                error={errors.officeSf}
                                value={data.officeSf}
                                onChange={handleAttributeUpdate}
                                disabled={disableInputs}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="retailSf"
                                label="RETAIL SPACE"
                                placeholder="Enter SF"
                                errorText="ex. 98101"
                                error={errors.retailSf}
                                value={data.retailSf}
                                onChange={handleAttributeUpdate}
                                disabled={disableInputs}
                            />
                        </div>
                    </div>
                </div>
            )}
            {context === "listing" && (
                <div>
                    <div className="multifamilyFlexContainer">
                        <div className="flexGrowSingle">
                            <BSInput
                                id="multifamilyUnitCount"
                                label="MULTIFAMILY UNIT COUNT"
                                placeholder="Enter count"
                                errorText="ex. 98"
                                error={errors.multifamilyUnitCount}
                                value={data.multifamilyUnitCount}
                                onChange={handleAttributeUpdate}
                                disabled={disableInputs}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="multifamilySf"
                                label="MULTIFAMILY SF"
                                placeholder="Enter SF"
                                errorText="ex. 98101"
                                error={errors.multifamilySf}
                                value={data.multifamilySf}
                                onChange={handleAttributeUpdate}
                                disabled={disableInputs}
                            />
                        </div>
                        <div className="flexGrowSingle">
                            <BSInput
                                id="bldgClass"
                                label="Multifamily Class"
                                error={errors.bldgClass}
                                value={data.bldgClass}
                                onChange={handleAttributeUpdate}
                                options={buildingClasses}
                                disabled={disableInputs}
                            />
                        </div>
                        {isAppraisalSale && (
                            <div className="flexGrowSingle">
                                <BSInput
                                    id="commercialSf"
                                    label="COMMERCIAL SF"
                                    placeholder="Enter commerical sf"
                                    error={errors.commercialSf}
                                    value={data.commercialSf}
                                    onChange={handleAttributeUpdate}
                                    disabled={disableInputs}
                                    integer
                                />
                            </div>
                        )}
                    </div>

                    <div className={isAppraisalSale ? "multifamilyCheckboxContainer" : "multifamilyFlexContainer"}>
                        <div className="multifamilyCheckboxes">
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={data.affordableHousingFlg ? true : false}
                                        onChange={(e, checked) => onChange(e.target.value, checked)}
                                        value="affordableHousingFlg"
                                        disabled={disableInputs === true}
                                        color="primary"
                                    />
                                }
                                label="Affordable Housing"
                            />
                            {isAppraisalSale && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={data.seniorHousingFlg ? true : false}
                                            onChange={(e, checked) => onChange(e.target.value, checked)}
                                            value="seniorHousingFlg"
                                            disabled={disableInputs === true}
                                            color="primary"
                                        />
                                    }
                                    label="Senior Housing"
                                />
                            )}
                        </div>
                        <div className="multifamilyCheckboxes">
                            {isAppraisalSale && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={data.lowIncomeHousingTaxCreditFlg ? true : false}
                                            onChange={(e, checked) => onChange(e.target.value, checked)}
                                            value="lowIncomeHousingTaxCreditFlg"
                                            disabled={disableInputs === true}
                                            color="primary"
                                        />
                                    }
                                    label="Low Income Housing Tax Credit (LIHTC)"
                                />
                            )}
                            <div className="multifamilyCheckboxContainer">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={data.wetlandsFlg ? true : false}
                                            onChange={(e, checked) => onChange(e.target.value, checked)}
                                            value="wetlandsFlg"
                                            disabled={disableInputs === true}
                                            color="primary"
                                        />
                                    }
                                    label="Wetlands"
                                />
                                <BSInput
                                    id="wetlandsPct"
                                    placeholder="Enter wetlands %"
                                    errorText="ex. 98.01"
                                    error={errors.wetlandsPct}
                                    value={data.wetlandsPct}
                                    onChange={handleAttributeUpdate}
                                    disabled={disableInputs}
                                    extraFormControlStyles={{ marginBottom: "0px" }}
                                    extraInputStyles={{ marginTop: "0px" }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div>
                <BSInput
                    id="unitMix"
                    label="UNIT MIX"
                    placeholder="Enter unit mix"
                    error={errors.unitMix}
                    value={data.unitMix}
                    onChange={handleAttributeUpdate}
                    disabled={disableInputs}
                />
            </div>
        </div>
    );
};

export default MultifamilyForm;
